import { MOBILE_GROUP_TAB_SELECTOR_HEIGHT } from '@photosi/rn-components/group-tab-selector/GroupTabSelector.constants';
import { MOBILE_MAIN_HEADER_V3_HEIGHT } from '../header-v3/HeaderV3.constants';

export const HEADER = {
  height: {
    mobile: 52,
    desktop: 60,
  },
};

export const HEADER_NEW = {
  height: {
    mobile: 54,
    tablet: 58,
    desktop: 80,
  },
};

export const HEADER_V3 = {
  height: {
    mobile: MOBILE_MAIN_HEADER_V3_HEIGHT + MOBILE_GROUP_TAB_SELECTOR_HEIGHT,
    tablet: 60,
    desktop: 72,
  },
};

export const HEADER_V4 = {
  height: {
    mobile: 60,
    tablet: 60,
    desktop: 80,
  },
};
